import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { useAppDispatch } from "../../../../redux/store";
import { useSelector } from "react-redux";

import styles from "./SmsRegCodeForm.module.scss";

import { SubmitValueType } from "./types";
import { fetchApplyCode, fetchReg } from "../../../../redux/profile/authAndReg/asyncActions";
import AuthCode from "react-auth-code-input";
import { useInterval } from "../../../../hooks/useInterval";
import { formatPhone } from "../../../../utils";
import { setToken } from "../../../../redux/auth/slice";
import { getSendCodeErrorMessage } from "../../../../helpers/sendCodeError";

type SmsRegCodeFormProps = {
  handleSubmitForm?: () => void;
  handleErrorForm?: () => void;
};

export const SmsRegCodeForm: React.FC<SmsRegCodeFormProps> = (props) => {
  const { handleSubmitForm, handleErrorForm } = props;
  const { phone, name, email, password } = useSelector((state: any) => state.changePass);
  const dispatch = useAppDispatch();
  const [errorCode, setErrorCode] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [resendError, setResendError] = React.useState<string>("");
  const [timer, setTimer] = React.useState(60);

  const initialValues = {
    code: [""],
  };

  const validationSchema = Yup.object({
    code: Yup.array().of(Yup.string().required("Required")),
  });

  const handleSubmit = async (values: SubmitValueType) => {
    try {
      const code = values.code.join("");

      const confirmData = {
        phone,
        code: Number(code),
      };

      const result = await dispatch(fetchApplyCode(confirmData)).unwrap();
      
      if (result.showWindow === "REGISTRATION_SUCCESS") {
        handleSubmitForm && handleSubmitForm();
        setErrorCode(false);
        setErrorMessage("");
      }
    } catch (error: any) {
      const errorMsg = typeof error === 'string' 
        ? error 
        : error?.message || 'Неверный код';
      
      setErrorCode(true);

      if (errorMsg.includes('истекло') || errorMsg.includes('истек')) {
        setErrorMessage("Время восстановления пароля истекло");
      } else if (errorMsg.includes('unique constraint') || errorMsg.includes('P2002')) {
        setErrorMessage("Пользователь с данным номером уже существует");
      } else {
        setErrorMessage("Неверный код");
      }
      
      if (handleErrorForm) {
        handleErrorForm();
      }
    }
  };

  useInterval(() => {
    setTimer(timer - 1);
  }, timer > 0 ? 1000 : null);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formik) => {
        return (
          <Form className={styles.form}>
            <p className={styles.description}>
              Код подтверждения отправлен на номер <br/> 
              <span className={styles.phone}>
                {formatPhone(phone)}
              </span>
            </p>

            <div className={styles.formSection}>
              <div className={styles.inputsWrapper}>
                <AuthCode
                  containerClassName={styles.inputsWrapper}
                  length={4}
                  inputClassName={`${styles.input} ${errorCode ? styles.input_error : ''}`}
                  allowedCharacters='numeric'
                  onChange={(v) => {
                    formik.setValues({ code: [v] });
                    
                    if (errorCode) {
                      setErrorCode(false);
                      setErrorMessage("");
                    }

                    if (v.length === 4) {
                      formik.handleSubmit();
                    }
                  }}
                />
              </div>
              {errorCode && !errorMessage ? (
                  <div className={`${styles.errorMessage}`}>
                    Неверный код подтверждения
                  </div>
                ) : null}
              {resendError ? (
                  <div className={`${styles.errorMessage}`}>{resendError}</div>
                ) : null}
            </div>

            <div className={styles.description}>
              {timer !== 0 ? (
                <span className={styles.timer}>
                  Отправить повторно через {' '}
                  <span className={styles.timer_time}>
                    {timer} сек.
                  </span>
                </span>
              ) : (
                <span
                  className={styles.resend}
                  onClick={async () => {
                    try {
                      const data = {
                        values: {
                          name: name,
                          email: email,
                          phone: phone,
                          password: password.password,
                          passwordRepeat: password.passwordRepeat,
                          acceptRules: true,
                        },
                        actions: {} as any,
                      };
              
                      await dispatch(fetchReg(data)).unwrap();
                      setTimer(60);
                      setErrorCode(false);
                      setErrorMessage("");
                      formik.setValues({ code: [""] });
                      setResendError("");
                    } catch (error) {
                      setResendError(getSendCodeErrorMessage((error as { message?: string })?.message));
                    }
                  }}
                >
                  Отправить код повторно
                </span>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
